export default "__VITE_ASSET__BY1h9gbz__"